/* filepath: /Users/george/MatrizInc/MarketBrewer/Clients/street-lawyer-services/website/src/core/Pages/ProductsPage/FeaturedProductsGrid/FeaturedProductsGrid.data.ts */
export interface FeaturedProduct {
  id: string;
  name: string;
  category: string;
  image: string;
  imageWebp?: string;
  gridSpan?: { col?: number; row?: number };
  description?: string;
  dimensions?: {
    width: number;
    height: number;
  };
}

export const featuredProducts: FeaturedProduct[] = [
  {
    id: "product-1",
    name: "Wedding Cake",
    category: "Premium Flower",
    description:
      "Potent indica-dominant hybrid with sweet vanilla and earthy notes",
    image: "/images/weed-joints-with-kief.jpg",
    imageWebp: "/images/weed-joints-with-kief.webp",
    gridSpan: { col: 2, row: 2 },
    dimensions: { width: 600, height: 600 }, // Add image dimensions
  },
  {
    id: "product-2",
    name: "Durban Poison",
    category: "Sativa Strain",
    description: "Pure South African sativa with sweet, piney aroma",
    image: "/images/weed-jar-and-street-lawyer-services-logo-1.jpg",
    imageWebp: "/images/weed-jar-and-street-lawyer-services-logo-1.webp",
    gridSpan: { col: 1, row: 1 },
    dimensions: { width: 600, height: 400 }, // Add image dimensions
  },
  {
    id: "product-3",
    name: "Blue Dream Pre-Rolls",
    category: "Pre-Rolls",
    description: "Expertly rolled hybrid joints with blueberry terpene profile",
    image: "/images/kief-infused-joints-inside-dispensary.jpg",
    imageWebp: "/images/kief-infused-joints-inside-dispensary.webp",
    gridSpan: { col: 1, row: 2 },
    dimensions: { width: 400, height: 600 }, // Add image dimensions
  },
  {
    id: "product-4",
    name: "DC Mota Skittles",
    category: "Edibles",
    description: "Precisely dosed fruit-flavored gummies for a balanced effect",
    image: "/images/edibles.jpg",
    imageWebp: "/images/edibles.webp",
    gridSpan: { col: 2, row: 1 },
    dimensions: { width: 600, height: 400 }, // Add image dimensions
  },
  {
    id: "product-5",
    name: "OG Kush",
    category: "Hybrid Strain",
    description: "Classic hybrid with woody, piney aroma and relaxing effects",
    image: "/images/weed-jars-from-street-lawyer-services.jpg",
    imageWebp: "/images/weed-jars-from-street-lawyer-services.webp",
    gridSpan: { col: 1, row: 1 },
    dimensions: { width: 400, height: 400 }, // Add image dimensions
  },
  {
    id: "product-6",
    name: "Donut Carts",
    category: "Vape Carts",
    description: "Delicious dessert-flavored high-potency vape cartridges",
    image: "/images/vape-cartridges.jpg",
    imageWebp: "/images/vape-cartridges.webp",
    gridSpan: { col: 1, row: 1 },
    dimensions: { width: 400, height: 400 }, // Add image dimensions
  },
];
